import {Swiper, SwiperSlide, useSwiper} from "swiper/react";
import {useSelector} from "react-redux";
import {portfolioSelecror} from "../../Selectors";
import {PortfolioItem} from "./PortfolioItem";
import SwiperCore from 'swiper';
import {NavigationOptions} from 'swiper/types/modules/navigation';
import {PaginationOptions} from 'swiper/types/modules/pagination';
import React, {useEffect, useRef, useState} from "react";

const SwiperBts = () => {

    const swiper = useSwiper()

    return <div className={'swiper_btns'}>
        <button className="prev" onClick={() => swiper.slidePrev()}>Prev</button>
        <button className="next" onClick={() => swiper.slideNext()}>Next</button>
    </div>
}


export const Portfolio = React.memo(() => {

    const portfolio = useSelector(portfolioSelecror)

    return <section className={'portfolio'}>
        <div className="portfolio_inner">
            <div className="title" >
                <h1>Портфолио</h1>
                <h2>Портфолио</h2>
            </div>
            <Swiper
                slidesPerView={3}
                speed={1000}
                spaceBetween={50} loop={true}
                centeredSlides={true}
                breakpoints={{
                    769: {
                        slidesPerView: 3,
                    },
                    320: {
                        slidesPerView: 1,
                    },
                }}>
                {portfolio.map((item, idx) => {
                    return <SwiperSlide key={idx}>
                        <PortfolioItem item={item}/>
                    </SwiperSlide>
                })}
                <SwiperBts />
            </Swiper>
        </div>
    </section>
})